
import StatisticsBase from './components/StatisticsBase';
import ChartMobile from './components/ChartMobile';
import NoData from './components/NoData';

export default {
  i18nComponentKey: 'WidgetProductReviewsStatistics.WidgetProductReviewsStatisticsMobile',
  name: 'WidgetProductReviewsStatisticsMobile',
  components: { ChartMobile, NoData },
  extends: StatisticsBase
};
